import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../common/widgets/Icons';
import { AccountInfoContext } from '../../contexts/AccountInfoContext';
import { resources } from '../../resources/resources';

export function WelcomePanel() {
  const { t: translate } = useTranslation();
  const { accountInfo } = useContext(AccountInfoContext);

  return (
    <div className="user-panel">
      <div className="up-welcome">
        {translate(resources.userPanel.welcome, {
          0: accountInfo.manufacturerName,
        })}
      </div>
      <div className="up-active-products">
        <Icons.MWelcomeProducts />
        <span>
          {translate(resources.userPanel.noProdActive, {
            0: accountInfo.activeProductsNumber,
          })}
        </span>
      </div>
    </div>
  );
}
